import * as t from 'io-ts';
export var AcceptConsentResult = t.type({
  __typename: t.literal('AcceptConsentResult'),
  consentStatus: t["boolean"]
});
export var AcceptConsentErrors = t.type({
  __typename: t.literal('AcceptConsentErrors')
});